import Icon from "../../Icon/Icon";
import SVGIcon from "../../Icon/SVGIcon";
import Tooltip from "../../wrappers/Tooltip/Tooltip";
import { CSSProperties } from "react";
import { Color } from "../../../../utils/sys/Color";

import { ReactElement, useMemo } from "react";

import "./Button_style.css";

export type ButtonColor = "neutral" | "active" | "warning" | "cancel";

type Props = Readonly<{
    color?: ButtonColor;
    disabled?: boolean;
    label?: string;
    icon?:
        | string
        | React.ReactElement<typeof Icon>
        | React.ReactElement<typeof SVGIcon>
        | null;
    iconSize?: number;
    style?: CSSProperties;
    tooltip?: string;
    onClick?: (event: React.MouseEvent) => void;
}>

export default function Button({color, disabled = false, label, icon, iconSize = 16, style, tooltip, onClick}: Props): ReactElement {

    const buttonIcon = useMemo((): React.ReactElement | null => {
        if (icon == null) {
            return null;
        }

        if (typeof icon === "string") {
            return (
                <img
                    alt={icon}
                    src={icon}
                    width={iconSize ?? 16}
                    height={iconSize ?? 16}
                />
            );
        }

        return icon;
    }, [icon, iconSize]);

    const buttonColor = useMemo((): Color | undefined => {
        if (color == null) {
            return undefined;
        }

        switch (color) {
            case "neutral":
                return undefined;
            case "active":
                return "#ADD8E6";
            case "warning":
                return "#FFFFE0";
            case "cancel":
                return "#FFCCCB";
        }
    }, [color]);

    const buttonStyle = useMemo((): CSSProperties => {
        return {
            ...style,
            height: style?.height ?? 30,
            margin: style?.margin ?? 2,
            backgroundColor: buttonColor,
            pointerEvents: style?.pointerEvents ?? "all",
        };
    }, [buttonColor, style]);

    return (
        <>
            {tooltip == null ? (
                <button type="button" className={onClick != null ? "operational" : undefined} style={buttonStyle} onClick={onClick} disabled={disabled}>
                    {buttonIcon}
                    {buttonIcon != null && label != null ? (
                        <div style={{ width: 8 }} />
                    ) : null}
                    {label}
                </button>
            ) : (
                <Tooltip delay={1000} tooltipContent={tooltip}>
                    <button type="button" className={onClick != null ? "operational" : undefined}  style={buttonStyle} onClick={onClick} disabled={disabled}>
                        {buttonIcon}
                        {buttonIcon != null && label != null ? (
                            <div style={{ width: 8 }} />
                        ) : null}
                        {label}
                    </button>
                </Tooltip>
            )}
        </>
    );
}
